/* ac-glycol.js: the glycol freeze point calculator (sections/ac-glycol.liquid, templates/page.ac-glycol.json).

   Pure core first, exposed as window.__acGlycol and tested in scripts/__tests__/ac-glycol.test.js. The DOM layer
   at the bottom runs only when there is a document. The page's charts and FAQ numbers are generated from this
   same core by scripts/ac-glycol/build-data.mjs, so the tables and the calculator cannot disagree.

   Every number comes from Dow's tables (the DATA block below, generated from scripts/ac-glycol/glycol-data.json):
   - rows: one row per Dow table line: % glycol by volume and weight, % Dow fluid by volume, freeze point,
     boiling point, Brix and refractive index at 22 C. Values between rows are interpolated linearly.
   - protect: % Dow FLUID by volume Dow lists for freeze and for burst protection at 20 to -60 F. Fluid % is
     converted to % glycol by volume through the rows' fluid -> glycol columns.
   Nothing is extrapolated past a table: outside it the answer says so in plain words. */
(function () {
  "use strict";

  var GAL_L = 3.785411784;

  /* BEGIN GENERATED DATA (scripts/ac-glycol/build-data.mjs; do not edit by hand) */
  // prettier-ignore
  var DATA = {"PG":{"name":"propylene glycol","short":"PG","fluid":"DOWFROST","rows":[[0,0,0,32,0,212,0,1.3328],[4.8,5,5.2,29.1,-1.6,212,4.8,1.3383],[9.6,10,10,26.1,-3.3,212,8.4,1.3438],[14.5,15,15.1,22.9,-5.1,212,12.9,1.3495],[19.4,20,20.3,19.2,-7.1,213,15.4,1.3555],[24.4,25,25.5,14.7,-9.6,214,19,1.3615],[29.4,30,30.7,9.2,-12.7,216,22,1.3675],[34.4,35,36,2.4,-16.4,217,26.1,1.3733],[39.6,40,41.4,-6,-21.1,219,29.1,1.379],[44.7,45,46.7,-16.1,-26.7,220,31.8,1.3847],[49.9,50,52.2,-28.3,-33.5,222,34.7,1.3903],[55,55,57.5,-42.8,-41.6,223,38,1.3956],[60,60,62.7,-59.9,-51.1,225,40.6,1.4008]],"protect":[[20,18.8,12.6,-7],[10,30.4,20.9,-12],[0,37.7,25.1,-18],[-10,44,29.3,-23],[-20,48.2,31.4,-29],[-30,52.4,34.6,-34],[-40,56.5,36.6,-40],[-50,59.7,36.6,-46],[-60,62.8,36.6,-51]],"source":"Dow DOWFROST Technical Data Sheet, Form 180-01314-1019"},"EG":{"name":"ethylene glycol","short":"EG","fluid":"DOWTHERM SR-1","rows":[[0,0,0,32,0,212,0,1.3328],[4.4,5,4.6,29.4,-1.4,213,3.8,1.3378],[8.9,10,9.3,26.2,-3.2,214,6.8,1.3428],[13.6,15,14.2,22.2,-5.4,215,9.9,1.3478],[18.1,20,19,17.9,-7.8,216,13,1.353],[19.2,21,20.1,16.8,-8.4,216,13.7,1.354],[20.1,22,21,15.9,-8.9,216,14.3,1.3551],[21,23,22,14.9,-9.5,217,14.8,1.3561],[22,24,23,13.7,-10.2,217,15.5,1.3572],[22.9,25,24,12.7,-10.7,218,16.1,1.3582],[23.9,26,25,11.4,-11.4,218,16.7,1.3593],[24.8,27,26,10.4,-12,218,17.3,1.3603],[25.8,28,27,9.2,-12.6,219,17.9,1.3614],[26.7,29,28,8,-13.3,219,18.6,1.3624],[27.7,30,29,6.7,-14.1,220,19.2,1.3635],[28.7,31,30.2,5.4,-14.8,220,19.8,1.3646],[29.6,32,31,4.2,-15.4,220,20.4,1.3656],[30.6,33,32,2.9,-16.2,220,21,1.3667],[31.6,34,33.1,1.4,-17,220,21.7,1.3678],[32.6,35,34.1,-0.2,-17.9,221,22.3,1.3688],[33.5,36,35.1,-1.5,-18.6,221,22.9,1.3699],[34.5,37,36.1,-3,-19.4,221,23.5,1.3709],[35.5,38,37.2,-4.5,-20.3,221,24.1,1.372],[36.5,39,38.2,-6.4,-21.3,221,24.7,1.373],[37.5,40,39.3,-8.1,-22.3,222,25.3,1.3741],[38.5,41,40.3,-9.8,-23.2,222,25.9,1.3752],[39.5,42,41.4,-11.7,-24.3,222,26.5,1.3763],[40.5,43,42.4,-13.5,-25.3,223,27.1,1.3774],[41.5,44,43.5,-15.5,-26.4,223,27.7,1.3785],[42.5,45,44.5,-17.5,-27.5,224,28.3,1.3796],[43.5,46,45.5,-19.8,-28.8,224,28.8,1.3807],[44.5,47,46.6,-21.6,-29.8,224,29.4,1.3817],[45.5,48,47.6,-23.9,-31.1,224,30,1.3828],[46.6,49,48.8,-26.7,-32.6,224,30.7,1.3838],[47.6,50,49.8,-28.9,-33.8,225,31.2,1.3849],[48.6,51,50.9,-31.2,-35.1,225,31.7,1.3859],[49.6,52,51.9,-33.6,-36.4,225,32.3,1.3869],[50.6,53,53,-36.2,-37.9,226,32.8,1.3879],[51.6,54,54,-38.8,-39.3,226,33.3,1.389],[52.7,55,55.2,-42,-41.1,227,33.9,1.39],[53.7,56,56.2,-44.7,-42.6,227,34.4,1.391],[54.7,57,57.3,-47.5,-44.2,228,35,1.3921],[55.7,58,58.3,-50,-45.6,228,35.5,1.3931],[56.8,59,59.5,-52.7,-47.1,229,36,1.3942],[57.8,60,60.5,-54.9,-48.3,230,36.6,1.3952]],"protect":[[20,16.8,11.5,-7],[10,26.2,17.8,-12],[0,34.6,23.1,-18],[-10,40.9,27.3,-23],[-20,46.1,31.4,-29],[-30,50.3,31.4,-34],[-40,54.5,31.4,-40],[-50,58.7,31.4,-46],[-60,62.9,31.4,-51]],"source":"Dow DOWTHERM SR-1 Engineering and Operating Guide, Table 3, and SR-1 Technical Data Sheet"}};
  /* END GENERATED DATA */

  /* Past the end of each freeze table (glycol-data.json stops at 60 wt%), from the same Dow tables:
     DOWFROST TDS: 65 to 95% PG by volume (= wt%), footnote a: "Freezing points are below -50 C (-60 F)".
     SR-1 guide Table 3: 62.8 to 73.6% EG by volume, footnote b: "Freezing points are below -60 F (-51 C)"; then real
     rows again, where more EG raises the freeze point: [vol%, F, C] 78.9 -52.2 -46.8, 84.3 -34.5 -36.9,
     89.7 -21.6 -29.8, 95.0 -3 -19.4.
     Dow: "The maximum recommended concentration of glycol is 60% for efficient heat transfer." */
  // prettier-ignore
  var BEYOND = {
    PG: { footFrom: 65, footTo: 95, foot: "below -50\u00a0°C (-60\u00a0°F)" },
    EG: { footFrom: 62.8, footTo: 73.6, foot: "below -60\u00a0°F (-51\u00a0°C)", high: [[78.9, -52.2, -46.8], [84.3, -34.5, -36.9], [89.7, -21.6, -29.8], [95, -3, -19.4]] },
  };
  var CHART_END = 95; /* both Dow charts stop at 95% glycol */
  var BURST_MAX_VOL = 60; /* Dow's burst figures are for working mixes; past 60% glycol they are not rated here */

  /* row columns */
  var VOL = 0,
    WT = 1,
    FLUID = 2,
    FP_F = 3,
    FP_C = 4,
    BP_F = 5,
    BRIX = 6,
    RI = 7;

  /* Alliance premixes by line: label % -> product handle (live handles checked 2026-11-02). Labels are % glycol by
     volume on every line, PG Inhibited and the OAT coolants included (Andre ruling 2026-11-03: ASTM D3306/D6210, Dow). */
  // prettier-ignore
  var LINES = {
    PG: [
      { id: "inhibited", short: "inhibited", label: "Inhibited (HVAC/process)", mixes: { 20: "propylene-glycol-20-inhibited", 30: "30-propylene-glycol-inhibited", 40: "40-propylene-glycol-inhibited", 50: "50-propylene-glycol-inhibited", 60: "propylene-glycol-60-inhibited" }, conc: "100-propylene-glycol-inhibited", concName: "100% Propylene Glycol, Inhibited" },
      { id: "usp", short: "USP", label: "USP (food/pharma)", mixes: { 20: "propylene-glycol-20-usp-grade", 30: "30-propylene-glycol-usp-grade", 40: "40-propylene-glycol-usp-grade", 50: "50-propylene-glycol-usp-grade", 60: "propylene-glycol-60-usp-grade" }, conc: "propylene-glycol-usp-grade", concName: "Propylene Glycol, USP Grade" },
      { id: "technical", short: "technical", label: "Technical", mixes: { 20: "propylene-glycol-20-technical-grade", 30: "30-propylene-glycol-technical-grade", 40: "40-propylene-glycol-technical-grade", 50: "50-propylene-glycol-technical-grade", 60: "propylene-glycol-60-technical-grade" }, conc: "propylene-glycol-technical-grade", concName: "Propylene Glycol, Technical Grade" },
      { id: "oat", short: "OAT data center", label: "Data center (OAT)", mixes: { 20: "inhibited-propylene-glycol-20-80-with-oat-inhibitor-data-center-coolant", 25: "inhibited-propylene-glycol-25-75-with-oat-inhibitor-data-center-coolant", 30: "inhibited-propylene-glycol-30-70-with-oat-inhibitor-heat-transfer-fluid", 35: "inhibited-propylene-glycol-35-65-with-oat-inhibitor-data-center-coolant", 40: "inhibited-propylene-glycol-40-60-with-oat-inhibitor-heat-transfer-fluid", 50: "inhibited-propylene-glycol-50-50-with-oat-inhibitor-heat-transfer-fluid" }, conc: null },
    ],
    EG: [
      { id: "technical", short: "technical", label: "Technical", mixes: { 30: "ethylene-glycol-30-70", 40: "ethylene-glycol-40-60", 50: "ethylene-glycol-50-50", 60: "ethylene-glycol-60-40" }, conc: null },
      { id: "inhibited", short: "inhibited", label: "Inhibited (HVAC/process)", mixes: {}, conc: "100-ethylene-glycol-inhibited", concName: "100% Ethylene Glycol, Inhibited" },
      { id: "oat", short: "OAT data center", label: "Data center (OAT)", mixes: { 20: "inhibited-ethylene-glycol-20-80-with-oat-908-data-center-coolant", 30: "inhibited-ethylene-glycol-30-70-with-oat-908-data-center-coolant", 35: "inhibited-ethylene-glycol-35-65-with-oat-908-data-center-coolant", 40: "inhibited-ethylene-glycol-40-60-with-oat-908-data-center-coolant", 50: "inhibited-ethylene-glycol-50-50-with-oat-908-data-center-coolant" }, conc: null },
    ],
  };
  var LINE_WORD = {
    inhibited: "Inhibited",
    usp: "USP Grade",
    technical: "Technical Grade",
    oat: "OAT inhibited, data center coolant",
  };
  var PACKS = [5, 55, 275, 330]; /* every glycol product above is sold in 5 gal pails, 55 gal drums, 275 and 330 gal totes */
  var QUOTE_ABOVE_GAL = 200;
  var MARGIN_F = 5;

  /* ---------- helpers ---------- */
  function num(v) {
    if (v === null || v === undefined || v === "") return NaN;
    var n = typeof v === "number" ? v : parseFloat(String(v).replace(/,/g, ""));
    return isFinite(n) ? n : NaN;
  }
  /* y at x along points (xs, ys); xs monotonic either way. null outside the range. */
  function interp(xs, ys, x) {
    for (var i = 0; i < xs.length - 1; i++) {
      var a = xs[i],
        b = xs[i + 1];
      if ((x >= a && x <= b) || (x <= a && x >= b)) {
        if (a === b) return ys[i];
        return ys[i] + ((ys[i + 1] - ys[i]) * (x - a)) / (b - a);
      }
    }
    return null;
  }
  function col(g, c) {
    return DATA[g].rows.map(function (r) {
      return r[c];
    });
  }
  function round(n, d) {
    var f = Math.pow(10, d);
    return Math.round(n * f) / f;
  }
  function ceil1(n) {
    /* round a needed % up to 0.1, so the answer never falls short of the table */
    return Math.ceil(round(n * 10, 6)) / 10;
  }
  function trim(n, d) {
    var s = round(n, d).toFixed(d);
    if (d > 0) s = s.replace(/\.?0+$/, "");
    return s === "-0" ? "0" : s;
  }
  function fixed1(n) {
    var s = round(n, 1).toFixed(1);
    return s === "-0.0" ? "0.0" : s;
  }
  function fToC(f) {
    return ((f - 32) * 5) / 9;
  }
  function cToF(c) {
    return (c * 9) / 5 + 32;
  }
  function degF(f) {
    return fixed1(f) + "\u00a0°F";
  }
  function degC(c) {
    return fixed1(c) + "\u00a0°C";
  }
  function temp(f, unit) {
    return unit === "C" ? trim(fToC(f), 1) + "\u00a0°C" : trim(f, 1) + "\u00a0°F";
  }
  function tempBoth(f, c, unit) {
    if (c === undefined || c === null) c = fToC(f);
    return unit === "C" ? degC(c) + " (" + degF(f) + ")" : degF(f) + " (" + degC(c) + ")";
  }
  function pct(n) {
    return fixed1(n) + "%";
  }
  function toGal(v, unit) {
    return unit === "L" ? v / GAL_L : v;
  }
  function vol(v, unit) {
    var d = Math.abs(v) >= 1000 ? 0 : Math.abs(v) >= 10 ? 1 : 2;
    return trim(v, d) + (unit === "L" ? " L" : " gal");
  }
  function err(code, message) {
    return { ok: false, code: code, message: message };
  }
  function known(g) {
    return g === "PG" || g === "EG";
  }
  function maxVol(g) {
    var r = DATA[g].rows;
    return r[r.length - 1][VOL];
  }

  /* ---------- conversions ---------- */
  /* % Dow fluid by volume -> % glycol by volume. Past the last row (only Dow's -60 F freeze figures, 0.1 to 2.4
     points beyond) the last row's glycol share of the fluid is used: a unit conversion, not a freeze extrapolation. */
  function fluidToGlycol(g, fluid) {
    var v = interp(col(g, FLUID), col(g, VOL), fluid);
    if (v !== null) return v;
    var last = DATA[g].rows[DATA[g].rows.length - 1];
    return fluid > last[FLUID] ? (fluid * last[VOL]) / last[FLUID] : null;
  }
  function glycolToFluid(g, v) {
    var f = interp(col(g, VOL), col(g, FLUID), v);
    if (f !== null) return f;
    var last = DATA[g].rows[DATA[g].rows.length - 1];
    return v > last[VOL] ? (v * last[FLUID]) / last[VOL] : null;
  }

  /* lowest temperature (F) Dow rates a fluid % for burst protection; protect[] runs 20 -> -60 F */
  function burstTemp(g, v) {
    var p = DATA[g].protect;
    if (v > BURST_MAX_VOL + 1e-9) return { notRated: true };
    var fluid = glycolToFluid(g, v);
    var top = p[p.length - 1][2];
    if (fluid === null) return null;
    if (fluid >= top - 1e-9) {
      /* Dow's last burst figure is for -60 F: the end of its chart, not a claim about anything colder */
      return { tF: p[p.length - 1][0], chartEnd: true };
    }
    if (fluid < p[0][2]) return { warmerThan: p[0][0], needPct: fluidToGlycol(g, p[0][2]) };
    for (var i = 0; i < p.length - 1; i++) {
      if (fluid >= p[i][2] && fluid <= p[i + 1][2] && p[i + 1][2] > p[i][2])
        return { tF: p[i][0] + ((p[i + 1][0] - p[i][0]) * (fluid - p[i][2])) / (p[i + 1][2] - p[i][2]) };
    }
    return null;
  }

  /* ---------- a. freeze point of a mix ---------- */
  function freezeOf(g, v) {
    if (!known(g)) return err("glycol", "Pick propylene or ethylene glycol.");
    v = num(v);
    if (isNaN(v)) return err("pct", "Enter the percent glycol in your mix.");
    if (v < 0 || v > 100) return err("pct", "Enter a percent between 0 and 100.");
    var r = { ok: true, glycol: g, vol: v, inTable: v <= maxVol(g) };
    if (r.inTable) {
      var x = col(g, VOL);
      r.wt = interp(x, col(g, WT), v);
      r.fpF = interp(x, col(g, FP_F), v);
      r.fpC = interp(x, col(g, FP_C), v);
      r.bpF = interp(x, col(g, BP_F), v);
      r.brix = interp(x, col(g, BRIX), v);
      r.ri = interp(x, col(g, RI), v);
    } else {
      var b = BEYOND[g],
        hi = b.high || [];
      r.lastVol = maxVol(g);
      r.lastF = DATA[g].rows[DATA[g].rows.length - 1][FP_F];
      if (v < b.footFrom - 1e-9) r.beyond = "gap";
      else if (v <= b.footTo + 1e-9) r.beyond = "foot";
      else if (hi.length && v < hi[0][0] - 1e-9) r.beyond = "gap2";
      else if (hi.length && v <= hi[hi.length - 1][0] + 1e-9) {
        /* Dow's own rows past 75% EG, where the freeze point rises again */
        var hv = hi.map(function (h) { return h[0]; });
        r.beyond = "rises";
        r.fpF = interp(hv, hi.map(function (h) { return h[1]; }), v);
        r.fpC = interp(hv, hi.map(function (h) { return h[2]; }), v);
      } else r.beyond = "off";
    }
    r.burst = burstTemp(g, v);
    r.fluid = glycolToFluid(g, v);
    return r;
  }

  /* ---------- b. percent needed for a temperature ---------- */
  function need(g, tF, kind, margin, unit) {
    if (!known(g)) return err("glycol", "Pick propylene or ethylene glycol.");
    tF = num(tF);
    if (isNaN(tF)) return err("temp", "Enter your coldest expected temperature.");
    kind = kind === "burst" ? "burst" : "freeze";
    var t = margin ? tF - MARGIN_F : tF;
    var p = DATA[g].protect;
    var r = { ok: true, glycol: g, kind: kind, tF: tF, designF: t, margin: !!margin };
    if (t < p[p.length - 1][0] - 1e-9)
      return err(
        "cold",
        (unit === "C" ? "Dow's tables stop at -51\u00a0°C (-60\u00a0°F)" : "Dow's tables stop at -60\u00a0°F (-51\u00a0°C)") +
          (margin ? ", and the safety margin puts you at " + temp(t, unit) : "") +
          ". Talk to us about a fluid for that.",
      );
    if (t >= 32) {
      r.pct = 0;
      r.warm = true;
      return r;
    }
    var tFs = p.map(function (q) { return q[0]; });
    /* freeze protection: the higher of the freeze chart and Dow's freeze-protection column (where it reaches) */
    var chart = interp(col(g, FP_F), col(g, VOL), t);
    var fp = interp(tFs, p.map(function (q) { return q[1]; }), t);
    var dowFreeze = fp === null ? null : fluidToGlycol(g, fp);
    var freezePct = chart === null ? dowFreeze : dowFreeze === null ? chart : Math.max(chart, dowFreeze);
    if (kind === "freeze") {
      r.pct = ceil1(freezePct);
      r.fromProtect = dowFreeze !== null && (chart === null || dowFreeze > chart);
      return r;
    }
    /* burst protection: Dow's burst column; above 20 F its 20 F figure. Never more than freeze protection needs. */
    var burst;
    if (t > p[0][0]) {
      burst = fluidToGlycol(g, p[0][2]);
      r.warmCap = p[0][0];
    } else burst = fluidToGlycol(g, interp(tFs, p.map(function (q) { return q[2]; }), t));
    if (freezePct < burst) {
      burst = freezePct;
      r.capByFreeze = true;
    }
    r.pct = ceil1(burst);
    return r;
  }

  /* ---------- c. mix it ---------- */
  function mix(volume, target) {
    var V = num(volume),
      t = num(target);
    if (isNaN(V) || V <= 0) return err("volume", "Enter your system volume.");
    if (isNaN(t) || t <= 0 || t >= 100) return err("target", "Enter a target between 1% and 99% glycol.");
    return { ok: true, volume: V, target: t, glycol: (V * t) / 100, water: V - (V * t) / 100 };
  }

  /* ---------- d. refractometer ---------- */
  function readRefract(g, kind, reading) {
    if (!known(g)) return err("glycol", "Pick propylene or ethylene glycol.");
    var x = num(reading);
    kind = kind === "brix" ? "brix" : "ri";
    if (isNaN(x)) return err("reading", kind === "brix" ? "Enter your Brix reading." : "Enter your refractive index reading (nD).");
    var rows = DATA[g].rows,
      xs = col(g, kind === "brix" ? BRIX : RI),
      lo = xs[0],
      hi = xs[xs.length - 1];
    if (kind === "ri" && x > 1 && x < 1.3)
      return err("reading", "That reading is below water (1.3328 at 22 °C). Check the refractometer's zero with clean water.");
    if (x < lo - 1e-9)
      return err("reading", "That reading is below water (" + (kind === "brix" ? "0 Brix" : "1.3328") + "). Check the refractometer's zero with clean water.");
    if (x > hi + 1e-9)
      return err(
        "reading",
        "That reading is past Dow's chart, which stops at " +
          (kind === "brix" ? hi + " Brix" : hi.toFixed(4)) +
          " (" + pct(rows[rows.length - 1][VOL]) + " glycol). Check the scale is for " + DATA[g].name + ".",
      );
    var v = interp(xs, col(g, VOL), x);
    var f = freezeOf(g, v);
    f.reading = x;
    f.readingKind = kind;
    return f;
  }
  /* drain V x (target - current) / (100 - current) and refill with concentrate; or, to weaken, drain
     V x (current - target) / current and refill with water */
  function adjust(volume, current, target) {
    var V = num(volume),
      c = num(current),
      t = num(target);
    if (isNaN(V) || V <= 0) return err("volume", "Enter your system volume.");
    if (isNaN(t) || t < 0 || t >= 100) return err("target", "Enter a target between 0% and 99% glycol.");
    if (isNaN(c) || c < 0 || c >= 100) return err("current", "Enter the glycol % you have now.");
    if (Math.abs(t - c) < 0.05) return { ok: true, action: "none", drain: 0, volume: V, current: c, target: t };
    if (t > c) return { ok: true, action: "glycol", drain: (V * (t - c)) / (100 - c), volume: V, current: c, target: t };
    return { ok: true, action: "water", drain: (V * (c - t)) / c, volume: V, current: c, target: t };
  }

  /* ---------- premix + packs ---------- */
  function lines(g) {
    return LINES[g] || [];
  }
  function lineOf(g, id) {
    var ls = lines(g);
    for (var i = 0; i < ls.length; i++) if (ls[i].id === id) return ls[i];
    return ls[0] || null;
  }
  function mixName(g, p, line) {
    var n = g === "PG" ? "Propylene Glycol" : "Ethylene Glycol";
    return trim(p, 0) + "/" + trim(100 - p, 0) + " " + n + ", " + LINE_WORD[line.id];
  }
  /* the closest premix at or above the target (compared by volume) in a line; past the strongest one, the line's concentrate */
  function premix(g, lineId, target) {
    var line = lineOf(g, lineId),
      t = num(target);
    if (!line) return err("line", "No product line for that glycol.");
    if (isNaN(t)) return err("target", "No target %.");
    var ps = Object.keys(line.mixes)
      .map(Number)
      .sort(function (a, b) {
        return a - b;
      });
    for (var i = 0; i < ps.length; i++) {
      var v = ps[i]; /* label % is % by volume, the calculator's basis */
      if (v >= t - 1e-9)
        return { ok: true, kind: "premix", line: line.id, lineLabel: line.label, lineShort: line.short, pct: ps[i], volPct: v, handle: line.mixes[ps[i]], name: mixName(g, ps[i], line), url: "/products/" + line.mixes[ps[i]] };
    }
    if (line.conc)
      return { ok: true, kind: "concentrate", line: line.id, lineLabel: line.label, lineShort: line.short, pct: 100, handle: line.conc, name: line.concName, url: "/products/" + line.conc, strongest: ps.length ? ps[ps.length - 1] : null };
    return { ok: true, kind: "none", line: line.id, lineLabel: line.label, lineShort: line.short, strongest: ps.length ? ps[ps.length - 1] : null };
  }
  /* the line's own concentrate, or null (OAT, EG technical): never another line's, since OAT and conventional
     inhibitors must not be mixed. premix() past the strongest premix uses the same rule. */
  function concentrateFor(g, lineId) {
    var line = lineOf(g, lineId);
    return line && line.conc ? { handle: line.conc, name: line.concName, url: "/products/" + line.conc } : null;
  }
  function packs(gallons) {
    var n = num(gallons);
    if (isNaN(n) || n <= 0) return null;
    var t275 = Math.ceil(n / 275 - 1e-9),
      t330 = Math.ceil(n / 330 - 1e-9);
    /* the tote size that leaves the least over; fewer totes on a tie */
    var tote = t330 * 330 - n < t275 * 275 - n || (t330 * 330 - n === t275 * 275 - n && t330 < t275) ? { size: 330, count: t330 } : { size: 275, count: t275 };
    return {
      gallons: n,
      pails: Math.ceil(n / 5 - 1e-9),
      drums: Math.ceil(n / 55 - 1e-9),
      tote: tote,
      quote: n > QUOTE_ABOVE_GAL,
    };
  }
  /* the quote page (sections/ac-ind-buy-quote.liquid) prefills "Products requested" for source=glycol-calc */
  function quoteUrl(name, handle, gallons) {
    var g = num(gallons);
    return (
      "/pages/request-a-quote?source=glycol-calc&product=" + encodeURIComponent(name) +
      (handle ? "&handle=" + encodeURIComponent(handle) : "") +
      (g > 0 ? "&gallons=" + Math.ceil(g - 1e-9) : "")
    );
  }

  /* ---------- words: the result each tab shows (the DOM layer and the build script both use this) ---------- */
  var DEFAULTS = { g: "PG", tab: "freeze", pct: "30", temp: "0", tu: "F", kind: "freeze", margin: "1", vol: "100", vu: "gal", target: "30", line: "", rk: "ri", read: "1.3675", goal: "" };
  var KEYS = Object.keys(DEFAULTS);
  var TABS = ["freeze", "need", "mix", "check"];

  function state(params) {
    var s = {};
    KEYS.forEach(function (k) {
      var v = params && params[k] !== undefined && params[k] !== null ? String(params[k]) : DEFAULTS[k];
      s[k] = v;
    });
    s.g = s.g.toUpperCase() === "EG" ? "EG" : "PG";
    if (TABS.indexOf(s.tab) < 0) s.tab = "freeze";
    s.tu = s.tu === "C" ? "C" : "F";
    s.vu = s.vu === "L" ? "L" : "gal";
    s.kind = s.kind === "burst" ? "burst" : "freeze";
    s.margin = s.margin === "0" ? "0" : "1";
    s.rk = s.rk === "brix" ? "brix" : "ri";
    s.line = lineOf(s.g, s.line).id;
    if (s.rk === "brix" && !(params && params.read)) s.read = "22";
    return s;
  }

  function burstWords(b, unit) {
    if (!b || b.notRated) return "Not rated above " + BURST_MAX_VOL + "% glycol";
    if (b.chartEnd) return (unit === "C" ? "-51\u00a0°C" : "-60\u00a0°F") + " (end of Dow's chart)";
    if (b.warmerThan !== undefined) return "Not rated (Dow's burst chart starts at " + temp(b.warmerThan, unit) + ")";
    return temp(b.tF, unit);
  }
  /* words for a freeze point past the end of the chart */
  function beyondHeadline(f, unit) {
    var lead = "A " + trim(f.vol, 1) + "% " + DATA[f.glycol].name + " mix ";
    var b = BEYOND[f.glycol];
    if (f.beyond === "gap") return lead + "freezes colder than " + tempBoth(f.lastF, null, unit) + ".";
    if (f.beyond === "foot") return lead + "freezes " + b.foot + ", per Dow.";
    if (f.beyond === "gap2") return lead + "falls between two of Dow's rows: " + pct(b.footTo) + " freezes " + b.foot + " and " + pct(b.high[0][0]) + " at " + tempBoth(b.high[0][1], b.high[0][2], unit) + ".";
    if (f.beyond === "rises") return lead + "freezes at " + tempBoth(f.fpF, f.fpC, unit) + ".";
    return lead + "is past Dow's chart, which stops at " + CHART_END + "% glycol.";
  }
  function beyondBasis(f, unit) {
    var b = BEYOND[f.glycol];
    if (f.beyond === "gap") return "Dow's chart lists " + pct(f.lastVol) + " at " + tempBoth(f.lastF, null, unit) + " and " + pct(b.footFrom) + " to " + pct(b.footTo) + " as " + b.foot + ".";
    if (f.beyond === "rises" || f.beyond === "gap2") return "Past about " + trim(b.footTo, 0) + "%, more ethylene glycol raises the freeze point again (Dow, DOWTHERM SR-1 guide, Table 3).";
    if (f.beyond === "foot") return "Dow's chart gives no exact number past " + pct(f.lastVol) + ", only " + b.foot + ".";
    return "";
  }
  function freezeWords(f, unit) {
    if (f.inTable || f.beyond === "rises") return tempBoth(f.fpF, f.fpC, unit);
    if (f.beyond === "gap") return "Colder than " + tempBoth(f.lastF, null, unit);
    if (f.beyond === "foot") return BEYOND[f.glycol].foot.charAt(0).toUpperCase() + BEYOND[f.glycol].foot.slice(1);
    return "Past Dow's chart";
  }
  var NOTE = {
    burst: "Freeze point: ice crystals start to form and the fluid turns to slush that won't pump. Burst protection: still slush, but it won't expand enough to split pipes.",
    low: "Dow: under 25 to 30% glycol the inhibitors may not give enough corrosion protection, and under 25% the fluid can grow bacteria.",
    max: "Dow recommends no more than 60% glycol for efficient heat transfer.",
    eg: "Ethylene glycol is toxic. Use propylene glycol (USP) wherever food or drinking water could be touched.",
    scale: "Use a refractometer scale made for that glycol: propylene and ethylene glycol read differently.",
    oat: "Don't mix OAT and conventional inhibited fluids in one system.",
    lean: "This treats the concentrate as 100% glycol. Inhibited concentrates are slightly less (Dow's DOWFROST and DOWTHERM SR-1 are about 95 to 96% glycol), so the mix can come out slightly lean; check it with a refractometer and top up if needed.",
  };
  function contextNotes(g, p, out) {
    if (p > 0 && p < 30) out.push(NOTE.low);
    if (p > 60) out.push(NOTE.max);
    if (g === "EG") out.push(NOTE.eg);
    return out;
  }
  function refractFigure(f) {
    if (f.ri === undefined || f.ri === null) return null;
    return { label: "Refractometer", value: "nD " + f.ri.toFixed(4) + " · " + trim(f.brix, 1) + " Brix" };
  }

  function describe(params) {
    var s = state(params);
    var g = s.g,
      name = DATA[g].name,
      unit = s.tu,
      out = { ok: true, state: s, figures: [], steps: [], notes: [], basis: "", share: 0, buy: null };
    function fig(label, value) {
      if (label && typeof label === "object") out.figures.push(label);
      else if (value) out.figures.push({ label: label, value: value });
    }

    if (s.tab === "freeze") {
      var f = freezeOf(g, s.pct);
      if (!f.ok) return f;
      out.share = Math.min(1, f.vol / 100);
      if (f.inTable) {
        out.headline = "A " + trim(f.vol, 1) + "% " + name + " mix freezes at " + tempBoth(f.fpF, f.fpC, unit) + ".";
        out.basis = "Percent glycol by volume, the way 30/70 and 40/60 mixes are sold. Values between Dow's table rows are interpolated.";
        fig("Freeze point", tempBoth(f.fpF, f.fpC, unit));
        fig("Burst protection to", burstWords(f.burst, unit));
        fig("By weight", pct(f.wt) + " glycol");
        fig("Boiling point", trim(f.bpF, 0) + " °F");
        var rf = refractFigure(f);
        if (rf) fig(rf);
      } else {
        out.headline = beyondHeadline(f, unit);
        out.basis = beyondBasis(f, unit);
        fig("Freeze point", freezeWords(f, unit));
        fig("Burst protection to", burstWords(f.burst, unit));
      }
      out.notes.push(NOTE.burst);
      contextNotes(g, f.vol, out.notes);
      out.buyPct = f.vol;
    } else if (s.tab === "need") {
      var tF = unit === "C" ? cToF(num(s.temp)) : num(s.temp);
      var r = need(g, tF, s.kind, s.margin === "1", unit);
      if (!r.ok) return r;
      var other = need(g, tF, s.kind === "burst" ? "freeze" : "burst", s.margin === "1", unit);
      var word = s.kind === "burst" ? "burst protection" : "freeze protection";
      if (r.warm) {
        out.headline = "Water alone won't freeze at " + temp(r.designF, unit) + ". You don't need glycol to protect against freezing.";
        out.basis = "Glycol still carries the corrosion inhibitors: Dow's guidance is at least 25 to 30% glycol in an inhibited system.";
        out.share = 0;
        out.buyPct = 30;
      } else {
        out.headline = "Use " + pct(r.pct) + " " + name + " by volume for " + word + " to " + temp(r.designF, unit) + ".";
        out.basis = r.margin
          ? "Your coldest day, " + temp(r.tF, unit) + ", minus Dow's 5 °F (3 °C) safety margin. Rounded up to the next 0.1%."
          : "No safety margin added: Dow suggests designing at least 5 °F (3 °C) below your coldest day.";
        out.share = r.pct / 100;
        fig(s.kind === "burst" ? "Burst protection" : "Freeze protection", pct(r.pct) + " glycol");
        if (other.ok && !other.warm) fig(s.kind === "burst" ? "Freeze protection" : "Burst protection", pct(other.pct) + " glycol");
        var fw = freezeOf(g, r.pct);
        if (fw.ok && fw.inTable) {
          fig("By weight", pct(fw.wt) + " glycol");
          fig("Freeze point at " + pct(r.pct), tempBoth(fw.fpF, fw.fpC, unit));
        }
        if (r.capByFreeze)
          out.notes.push("Here the freeze-protection figure is lower than Dow's burst figure, and a mix that doesn't freeze can't burst a pipe, so this uses it.");
        else if (r.warmCap !== undefined)
          out.notes.push("Dow's burst chart starts at " + temp(r.warmCap, unit) + "; " + pct(r.pct) + " covers anything warmer.");
        if (r.fromProtect) out.notes.push("Dow's freeze-protection table asks for a little more glycol here than its freeze point chart, so this uses the higher number.");
        out.notes.push(NOTE.burst);
        contextNotes(g, r.pct, out.notes);
        out.buyPct = r.pct;
      }
    } else if (s.tab === "mix") {
      var m = mix(s.vol, s.target);
      if (!m.ok) return m;
      out.headline =
        "Mix " + vol(m.glycol, s.vu) + " of " + name + " with " + vol(m.water, s.vu) + " of water to make " + vol(m.volume, s.vu) + " at " + trim(m.target, 1) + "%.";
      out.basis = "By volume. Treats the concentrate as 100% glycol (footnote below).";
      out.share = m.target / 100;
      out.steps.push("Start with " + vol(m.water, s.vu) + " of clean water.");
      out.steps.push("Add " + vol(m.glycol, s.vu) + " of " + name + " concentrate and mix well.");
      var fm = freezeOf(g, m.target);
      if (fm.ok && fm.inTable)
        out.steps.push("Check it: a " + trim(m.target, 1) + "% mix reads about nD " + fm.ri.toFixed(4) + " (" + trim(fm.brix, 1) + " Brix) at 22 °C.");
      fig("Glycol concentrate", vol(m.glycol, s.vu));
      fig("Water", vol(m.water, s.vu));
      if (fm.ok) fig("Freeze point", freezeWords(fm, unit));
      if (fm.ok) fig("Burst protection to", burstWords(fm.burst, unit));
      out.notes.push(NOTE.lean);
      contextNotes(g, m.target, out.notes);
      out.buyPct = m.target;
      out.buyGal = toGal(m.volume, s.vu);
      out.concGal = toGal(m.glycol, s.vu);
    } else {
      var rd = readRefract(g, s.rk, s.read);
      if (!rd.ok) return rd;
      var shown = s.rk === "brix" ? trim(rd.reading, 1) + " Brix" : "nD " + rd.reading.toFixed(4);
      out.headline =
        "A reading of " + shown + " means about " + pct(rd.vol) + " " + name + ", which freezes at " + tempBoth(rd.fpF, rd.fpC, unit) + ".";
      out.basis = "Read at 22 °C (72 °F) on a scale for " + name + ". Dow's refractive index and Brix columns, interpolated.";
      out.share = rd.vol / 100;
      fig("Glycol now", pct(rd.vol) + " by volume");
      fig("Freeze point", tempBoth(rd.fpF, rd.fpC, unit));
      fig("Burst protection to", burstWords(rd.burst, unit));
      out.buyPct = rd.vol;
      if (s.goal !== "") {
        var a = adjust(s.vol, rd.vol, s.goal);
        if (a.ok) {
          var gf = freezeOf(g, a.target);
          var gfw = gf.ok && gf.inTable ? " (freezes at " + temp(gf.fpF, unit) + ")" : "";
          if (a.action === "glycol") {
            out.steps.push("Drain " + vol(a.drain, s.vu) + " from the " + vol(a.volume, s.vu) + " system.");
            out.steps.push("Refill with " + vol(a.drain, s.vu) + " of " + name + " concentrate to reach " + trim(a.target, 1) + "%" + gfw + ".");
            fig("Drain and replace with concentrate", vol(a.drain, s.vu));
            out.concGal = toGal(a.drain, s.vu);
            out.buyConc = true;
            out.notes.push(NOTE.lean);
          } else if (a.action === "water") {
            out.steps.push("Drain " + vol(a.drain, s.vu) + " from the " + vol(a.volume, s.vu) + " system.");
            out.steps.push("Refill with " + vol(a.drain, s.vu) + " of clean water to bring it down to " + trim(a.target, 1) + "%" + gfw + ".");
            fig("Drain and replace with water", vol(a.drain, s.vu));
          } else out.steps.push("You're already at " + trim(a.target, 1) + "%. Nothing to add.");
          out.buyPct = a.target;
        } else out.notes.push(a.message);
      }
      out.notes.push(NOTE.scale, NOTE.oat, NOTE.low);
      if (g === "EG") out.notes.push(NOTE.eg);
    }

    /* the buy card */
    var lineId = s.line || lines(g)[0].id;
    var bp = out.buyConc ? { ok: true } : premix(g, lineId, out.buyPct);
    var buy = { line: lineId, lines: lines(g).map(function (l) { return { id: l.id, label: l.label }; }) };
    var lineNow = lineOf(g, lineId);
    var gName = g === "PG" ? "Propylene Glycol" : "Ethylene Glycol";
    if (out.buyConc) {
      var cc = concentrateFor(g, lineId);
      if (cc) {
        buy.kind = "concentrate";
        buy.name = cc.name;
        buy.url = cc.url;
        buy.handle = cc.handle;
        buy.lead = "To top up, buy " + vol(out.concGal, "gal") + " of concentrate.";
        buy.packs = packs(out.concGal);
      } else {
        buy.kind = "none";
        buy.handle = "";
        buy.quoteName = gName + " concentrate, " + LINE_WORD[lineNow.id];
        buy.quoteGal = out.concGal;
        buy.lead = "There's no " + lineNow.short + " " + name + " concentrate in the store. Ask us for " + vol(out.concGal, "gal") + ", and keep the top-up the same inhibitor type as the system.";
      }
    } else if (bp.ok && bp.kind === "premix") {
      buy.kind = "premix";
      buy.name = bp.name;
      buy.url = bp.url;
      buy.handle = bp.handle;
      buy.lead =
        Math.abs(bp.volPct - out.buyPct) < 0.05
          ? "Sold ready to use at " + trim(bp.volPct, 1) + "% by volume."
          : "Closest premix at or above " + trim(out.buyPct, 1) + "% by volume: " + trim(bp.pct, 0) + "%.";
      if (out.buyGal) buy.packs = packs(out.buyGal);
    } else if (bp.ok && bp.kind === "concentrate") {
      buy.kind = "concentrate";
      buy.name = bp.name;
      buy.url = bp.url;
      buy.handle = bp.handle;
      buy.lead = bp.strongest
        ? "No " + bp.lineShort + " premix is that strong (the strongest is " + bp.strongest + "%). Mix it from concentrate."
        : "Alliance sells " + bp.lineShort + " " + name + " as a concentrate. Mix it to strength with water.";
      if (out.concGal) buy.packs = packs(out.concGal);
    } else {
      buy.kind = "none";
      buy.lead = bp.ok && bp.strongest ? "The strongest " + bp.lineShort + " premix is " + bp.strongest + "%. Ask us about a custom blend." : "Ask us about a custom blend.";
      buy.handle = "";
      buy.quoteName = trim(out.buyPct, 1) + "% " + gName + ", " + LINE_WORD[lineNow.id] + " (custom blend)";
      buy.quoteGal = out.buyGal || 0;
    }
    if (s.tab === "mix" && buy.kind === "premix") {
      var cm = concentrateFor(g, lineId);
      if (cm) buy.diy = { name: cm.name, url: cm.url, gallons: out.concGal };
    }
    if (buy.packs && buy.packs.quote) buy.quoteUrl = quoteUrl(buy.name, buy.handle, buy.packs.gallons);
    if (buy.kind === "none") buy.quoteUrl = quoteUrl(buy.quoteName, "", buy.quoteGal);
    out.buy = buy;
    return out;
  }

  /* ---------- tables for the page (scripts/ac-glycol/build-data.mjs renders these server-side) ---------- */
  function chartRows(g) {
    return DATA[g].rows.map(function (r) {
      return { vol: r[VOL], wt: r[WT], fpF: r[FP_F], fpC: r[FP_C], ri: r[RI], brix: r[BRIX], bpF: r[BP_F] };
    });
  }
  function protectRows() {
    return DATA.PG.protect.map(function (q, i) {
      var t = q[0];
      return {
        tF: t,
        tC: q[3],
        PG: { freeze: need("PG", t, "freeze", false).pct, burst: need("PG", t, "burst", false).pct },
        EG: { freeze: need("EG", t, "freeze", false).pct, burst: need("EG", t, "burst", false).pct },
      };
    });
  }

  /* ---------- HTML for the result and the buy card (the DOM layer and the build script render the same markup) ---------- */
  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function buyHtml(b) {
    if (!b) return '<p class="ac-dilute__buy-need">Enter a mix above to see the matching product.</p>';
    var h = "";
    if (b.url) h += '<p class="ac-dilute__buy-title"><a href="' + esc(b.url) + '">' + esc(b.name) + "</a></p>";
    h += '<p class="ac-dilute__buy-need">' + esc(b.lead) + "</p>";
    if (b.packs) {
      var p = b.packs,
        rows = [];
      if (p.gallons <= 110) rows.push(["5 gal pails", p.pails]);
      rows.push(["55 gal drums", p.drums]);
      if (p.gallons > 55) rows.push([p.tote.size + " gal totes", p.tote.count]);
      h += '<p class="ac-glycol__packs-for">For ' + esc(vol(p.gallons, "gal")) + ", any one of:</p>";
      h += '<dl class="ac-glycol__packs">';
      rows.forEach(function (r) {
        h += "<div><dt>" + esc(r[0]) + "</dt><dd>" + r[1] + "</dd></div>";
      });
      h += "</dl>";
    } else if (b.kind !== "none") {
      h += '<p class="ac-dilute__buy-from">Sold in 5 gal pails, 55 gal drums and 275 or 330 gal totes. Enter a system size under Mix it to count them.</p>';
    }
    if (b.url || b.quoteUrl) {
      h += '<div class="ac-glycol__buy-acts">';
      if (b.quoteUrl)
        h += '<a class="ac-ind-btn ac-ind-btn--primary ac-glycol__cta" href="' + esc(b.quoteUrl) + '">' + (b.kind === "none" ? "Ask for a quote" : "Get a tote quote") + "</a>";
      if (b.url)
        h += '<a class="ac-ind-btn ' + (b.quoteUrl ? "ac-ind-btn--outline ac-glycol__btn2" : "ac-ind-btn--primary ac-glycol__cta") + '" href="' + esc(b.url) + '">See sizes and prices</a>';
      h += "</div>";
    }
    if (b.diy)
      h += '<p class="ac-glycol__diy">Mixing it yourself? <a href="' + esc(b.diy.url) + '">' + esc(b.diy.name) + "</a>, " + esc(vol(b.diy.gallons, "gal")) + ".</p>";
    return h;
  }

  var core = {
    DATA: DATA,
    BEYOND: BEYOND,
    LINES: LINES,
    DEFAULTS: DEFAULTS,
    PACKS: PACKS,
    interp: interp,
    fluidToGlycol: fluidToGlycol,
    glycolToFluid: glycolToFluid,
    burstTemp: burstTemp,
    freezeOf: freezeOf,
    need: need,
    mix: mix,
    readRefract: readRefract,
    adjust: adjust,
    premix: premix,
    packs: packs,
    quoteUrl: quoteUrl,
    state: state,
    describe: describe,
    chartRows: chartRows,
    protectRows: protectRows,
    fToC: fToC,
    cToF: cToF,
    fixed1: fixed1,
    trim: trim,
    buyHtml: buyHtml,
    burstWords: burstWords,
    freezeWords: freezeWords,
    concentrateFor: concentrateFor,
  };
  if (typeof window !== "undefined") window.__acGlycol = core;
  if (typeof module !== "undefined" && module.exports) module.exports = core;
  if (typeof document === "undefined") return;

  /* ====================================================================================================
     DOM layer
     ==================================================================================================== */
  function ga(name, params) {
    try {
      if (typeof window.gtag === "function") window.gtag("event", name, params);
    } catch (e) {
      /* analytics never breaks the calculator */
    }
  }
  function li(list, text) {
    var n = document.createElement("li");
    n.textContent = text;
    list.appendChild(n);
  }

  function mount(root) {
    if (root.__acGlycol) return;
    var form = root.querySelector("[data-ac-glycol-form]");
    var aside = root.querySelector("[data-ac-glycol-buy]");
    if (!form) return;
    root.__acGlycol = true;
    var $ = function (sel) {
      return form.querySelector(sel);
    };
    var out = {
      msg: $("[data-msg]"),
      result: $("[data-result]"),
      headline: $("[data-headline]"),
      basis: $("[data-basis]"),
      steps: $("[data-steps]"),
      figures: $("[data-figures]"),
      notes: $("[data-notes]"),
      tank: $("[data-tank]"),
      key: $("[data-key-conc]"),
      live: $("[data-live]"),
    };
    var tabs = Array.prototype.slice.call(form.querySelectorAll("[role=tab]"));
    var panels = Array.prototype.slice.call(form.querySelectorAll("[role=tabpanel]"));
    var lineSel = aside && aside.querySelector('[name="line"]');
    var tab = "freeze";
    var TEXT = ["pct", "temp", "vol", "target", "read", "goal"];
    /* the unit the temperature and reading fields are currently written in: a radio fires both input and change,
       so a toggle converts only when the unit really changes */
    var shownTu = "F",
      shownRk = "ri";

    /* vol and vu appear in two panels (Mix it, Check): read the visible one, keep both in step */
    function field(name) {
      return form.querySelector('[data-panel="' + tab + '"] [name="' + name + '"]') || form.querySelector('[name="' + name + '"]');
    }
    function all(name) {
      return Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]'));
    }
    function radio(name) {
      var c = form.querySelector('[name="' + name + '"]:checked');
      return c ? c.value : "";
    }
    function setRadio(name, v) {
      var r = form.querySelector('[name="' + name + '"][value="' + v + '"]');
      if (r) r.checked = true;
    }
    function read() {
      var p = { tab: tab, g: radio("g"), tu: radio("tu"), kind: radio("kind"), rk: radio("rk") };
      TEXT.concat(["vu"]).forEach(function (k) {
        var f = field(k);
        if (f) p[k] = f.value.trim();
      });
      var m = form.querySelector('[name="margin"]');
      p.margin = m && m.checked ? "1" : "0";
      p.line = lineSel ? lineSel.value : "";
      return p;
    }
    function fillLines(g, want) {
      if (!lineSel) return;
      var cur = want || lineSel.value;
      lineSel.innerHTML = "";
      lines(g).forEach(function (l) {
        var o = document.createElement("option");
        o.value = l.id;
        o.textContent = l.label;
        lineSel.appendChild(o);
      });
      lineSel.value = lineOf(g, cur).id;
    }
    function apply(params) {
      var s = state(params);
      setRadio("g", s.g);
      setRadio("tu", s.tu);
      setRadio("kind", s.kind);
      setRadio("rk", s.rk);
      TEXT.concat(["vu"]).forEach(function (k) {
        if (params[k] !== undefined || (k === "read" && params.rk))
          all(k).forEach(function (f) {
            f.value = s[k];
          });
      });
      var m = form.querySelector('[name="margin"]');
      if (m) m.checked = s.margin === "1";
      shownTu = s.tu;
      shownRk = s.rk;
      fillLines(s.g, s.line);
      showTab(s.tab, false);
    }
    function suffixes() {
      var rl = $("[data-read-suffix]");
      if (rl) rl.textContent = radio("rk") === "brix" ? "Brix" : "nD";
      var tl = $("[data-temp-suffix]");
      if (tl) tl.textContent = radio("tu") === "C" ? "°C" : "°F";
    }
    function showTab(id, focus) {
      if (TABS.indexOf(id) < 0) id = "freeze";
      tab = id;
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-tab") === id;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute("data-panel") !== id;
      });
      suffixes();
    }

    var gaTimer, liveTimer;
    var lastKey = "",
      lastSaid = "";
    /* screen readers hear the answer once typing pauses, not on every keystroke; the visible headline is not a
       live region. The error line is a status region: shown first, then its text set, and only when it changes. */
    function say(text) {
      clearTimeout(liveTimer);
      if (!out.live) return;
      liveTimer = setTimeout(function () {
        if (text === lastSaid) return;
        lastSaid = text;
        out.live.textContent = text;
      }, 900);
    }
    function update(push) {
      var r = describe(read());
      if (!r.ok) {
        clearTimeout(liveTimer);
        out.result.hidden = true;
        if (out.msg.hidden) out.msg.hidden = false;
        if (out.msg.textContent !== r.message) out.msg.textContent = r.message;
        if (aside) aside.querySelector("[data-buy-body]").innerHTML = buyHtml(null);
        return;
      }
      out.msg.hidden = true;
      out.msg.textContent = "";
      out.result.hidden = false;
      out.headline.textContent = r.headline;
      if (push !== false) say(r.headline);
      out.basis.textContent = r.basis || "";
      out.steps.innerHTML = "";
      out.figures.innerHTML = "";
      out.notes.innerHTML = "";
      r.steps.forEach(function (t) {
        li(out.steps, t);
      });
      out.steps.hidden = !r.steps.length;
      r.figures.forEach(function (f) {
        var w = document.createElement("div");
        var dt = document.createElement("dt");
        var dd = document.createElement("dd");
        dt.textContent = f.label;
        dd.textContent = f.value;
        w.appendChild(dt);
        w.appendChild(dd);
        out.figures.appendChild(w);
      });
      r.notes.forEach(function (t) {
        li(out.notes, t);
      });
      if (out.key) out.key.textContent = r.state.g === "EG" ? "Ethylene glycol" : "Propylene glycol";
      if (out.tank) out.tank.style.setProperty("--share", Math.max(0.02, Math.min(1, r.share)).toFixed(4));
      if (aside) aside.querySelector("[data-buy-body]").innerHTML = buyHtml(r.buy);

      /* the URL carries this tab's inputs (keeping view, preview_theme_id, utm_*), so a link reopens the answer */
      var s = r.state;
      var want = { freeze: ["pct"], need: ["temp", "tu", "kind", "margin"], mix: ["vol", "vu", "target"], check: ["rk", "read", "goal", "vol", "vu"] }[s.tab];
      var q = new URLSearchParams(location.search);
      KEYS.forEach(function (k) {
        q.delete(k);
      });
      q.set("g", s.g);
      q.set("tab", s.tab);
      want.forEach(function (k) {
        if (s[k] !== "") q.set(k, s[k]);
      });
      q.set("line", s.line);
      var key = q.toString();
      if (push !== false && key !== lastKey) {
        try {
          history.replaceState(null, "", location.pathname + "?" + key + location.hash);
        } catch (e) {
          /* Safari throttles replaceState; the next edit tries again */
        }
        clearTimeout(gaTimer);
        gaTimer = setTimeout(function () {
          ga("glycol_calculate", { glycol: s.g, tab: s.tab });
        }, 1000);
      }
      lastKey = key;
    }

    /* typing paints first; one pending update covers a burst of keys (same pattern as ac-dilute.js) */
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        setTimeout(function () {
          pending = false;
          update();
        }, 0);
      });
    }
    function onEdit(e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (e.type === "change" && t.tagName === "INPUT" && t.type === "number") return;
      if (t.name === "vol" || t.name === "vu")
        all(t.name).forEach(function (f) {
          if (f !== t) f.value = t.value;
        });
      if (t.name === "g") fillLines(t.value);
      if (t.name === "rk" && t.checked && t.value !== shownRk) {
        /* switching scales carries the reading over, so the answer doesn't jump to an error */
        var rf = field("read");
        var rd = readRefract(radio("g"), shownRk, rf.value);
        if (rd.ok && rd.ri !== undefined) rf.value = t.value === "brix" ? trim(rd.brix, 1) : rd.ri.toFixed(4);
        shownRk = t.value;
        suffixes();
      }
      if (t.name === "tu" && t.checked && t.value !== shownTu) {
        var tf = field("temp"),
          n = num(tf.value);
        if (!isNaN(n)) tf.value = trim(t.value === "C" ? fToC(n) : cToF(n), 1);
        shownTu = t.value;
        suffixes();
      }
      schedule();
    }
    form.addEventListener("input", onEdit);
    form.addEventListener("change", onEdit);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      update();
    });
    if (lineSel) lineSel.addEventListener("change", onEdit);

    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        showTab(t.getAttribute("data-tab"), false);
        update();
      });
      t.addEventListener("keydown", function (e) {
        var j = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") j = (i + 1) % tabs.length;
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === "Home") j = 0;
        else if (e.key === "End") j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        showTab(tabs[j].getAttribute("data-tab"), true);
        update();
      });
    });
    form.querySelectorAll("[data-preset]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var p = {};
        new URLSearchParams(a.getAttribute("data-preset")).forEach(function (v, k) {
          p[k] = v;
        });
        var cur = read();
        Object.keys(p).forEach(function (k) {
          cur[k] = p[k];
        });
        apply(cur);
        update();
      });
    });

    var copy = $("[data-copy]");
    if (copy)
      copy.addEventListener("click", function () {
        update();
        var done = function () {
          copy.textContent = "Link copied";
          setTimeout(function () {
            copy.textContent = "Copy link to this answer";
          }, 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done, done);
        else window.prompt("Copy this link", location.href);
      });
    var pr = $("[data-print]");
    if (pr)
      pr.addEventListener("click", function () {
        window.print();
      });

    var params = {};
    new URLSearchParams(location.search).forEach(function (v, k) {
      params[k] = v;
    });
    apply(params);
    update(false);
  }

  function init(scope) {
    if (scope.matches && scope.matches("[data-ac-glycol]")) mount(scope);
    scope.querySelectorAll("[data-ac-glycol]").forEach(mount);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  else init(document);
  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });
})();
